import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleUpGreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.4 0.162028C5.3514 0.111325 5.29033 0.070489 5.22117 0.0424535C5.15201 0.0144179 5.07648 -0.00012207 5 -0.00012207C4.92352 -0.00012207 4.84798 0.0144179 4.77882 0.0424535C4.70966 0.070489 4.64859 0.111325 4.6 0.162028L0.1 5.31307C0.0442867 5.37685 0.0103596 5.45268 0.00202058 5.53207C-0.0063184 5.61147 0.0112601 5.69129 0.0527866 5.76259C0.094313 5.83389 0.158147 5.89386 0.237135 5.93577C0.316123 5.97768 0.407144 5.99988 0.5 5.99988H9.5C9.59285 5.99988 9.68388 5.97768 9.76286 5.93577C9.84185 5.89386 9.90569 5.83389 9.94721 5.76259C9.98874 5.69129 10.0063 5.61147 9.99798 5.53207C9.98964 5.45268 9.95571 5.37685 9.9 5.31307L5.4 0.162028Z",
		fill: "#1E6A83"
	})
});
export default SvgTriangleUpGreen;
